import { isParseObject } from "@opendash/core";
import { SaveTicketValues } from "../..";
import { fetchMedia, TicketData } from "../../_shared";
import { splitMetaToFormFields } from "../../_shared/hooks/useTicketMeta";

export async function ticketDataToFormValues(
  data: TicketData
): Promise<SaveTicketValues> {
  return {
    existingTicketId: data?.ticket?.id,
    title: data?.ticket?.get("title"),
    description: data?.ticket?.get("description"),
    duedate: data?.duedate
      ? {
          start: data?.duedate?.get("start"),
          end: data?.duedate?.get("end"),
        }
      : undefined,
    source: data?.source?.id,
    issuecategory: data?.issuecategory?.id,
    priority: data?.priority?.value,
    restriction: data?.restriction?.value,
    downtime: data?.downtime?.value,
    frequency: data?.frequency?.value,
    project: data?.project?.id,
    state: data?.state?.id,
    assignedTo: data?.assignedTo?.map((ur) => ({
      type: isParseObject(ur, "User") ? "user" : "role",
      id: ur.id,
    })),
    material: data?.material?.get("itemList"),
    media: (await fetchMedia(data))?.map((media) => media.id),
    meta: await splitMetaToFormFields(data?.ticket?.get("meta")?.fields || []),
  };
}
